// languages available in the app and in the translations
export const LANGUAGES = ['EN', 'IT', 'HR'];

// statuses of controls and sidebar
export const CONTROLS_STATUSES = {
  DEFAULT: 1,
  LIST: 2,
  DETAIL: 3,
  CREDITS: 4,
};

// Application and API urls
export const URL = 'http://mizar.unive.it/underwatermuse/app';
export const FEATURES_API = '/locations';
export const UI_LABELS_API = '/ui-labels';
export const PARTNERS_PAGE_API = '/partners-page';
export const TAGS_API = '/tags';

// UI colors
export const COLORS = {
  YELLOW: '#FFC73B',
  GREEN: '#487A00',
  ORANGE: '#FF4802',
  BLUE: '#00848E'
}
